
import { useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";
import { useState } from "react";
import '../Styles/CheckoutForm.scss';


const CheckoutForm = ({setPaymentIntent, onProcessingChange}) => {
    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const handleSubmit = async (event) => {
        event.preventDefault();
        console.log("✅ handleSubmit function triggered!");
        if (!stripe || !elements)
         return;

        console.log("✅ Stripe.js after the if checks");

        setLoading(true);
        onProcessingChange?.(true);

        const { error, paymentIntent } = await stripe.confirmPayment({
            elements,
            redirect: 'if_required'

        });

        if (error) {
            setErrorMessage(error.message);
            console.error(error.message);
            setLoading(false);
            onProcessingChange?.(false);
        } else {
            // Leave loading/processing true — the parent flow still has to verify the
            // payment and create the registration before navigating to the success page.
            setPaymentIntent(paymentIntent)
            console.log("Payment Intent:", paymentIntent);
        }
    };

    return (
       <form onSubmit={handleSubmit}>
          <PaymentElement />
          {errorMessage && <div style={{ color: "red", marginTop: "10px", fontFamily: "Bebas Neue" }}>{errorMessage}</div>}
          <div className="paymentSubmitButton">
             <button type="submit" disabled={!stripe || loading}>
                {loading && <span className="paymentSpinner" aria-hidden="true"></span>}
                {loading ? "Processing..." : "Pay Now"}
             </button>
          </div>
          {loading &&
             <div className="paymentProcessingNotice">
                Please do not refresh or close this page until your payment is complete and you are redirected.
             </div>
          }
       </form>
    );
};

export default CheckoutForm;
